import { apiHelper } from '@/utils'
import { API } from '@/constants'

export const paymentService = { getAllPayments, getPayment }

const API_URL = API.BASE_URL + '/v1'

function buildParams(filter) {
  const params = { page: filter?.pageNumber, size: filter?.pageSize }
  if (filter?.debtorCode) params.debtor_code = filter.debtorCode
  if (filter?.dateFrom) params.date_from = filter.dateFrom
  if (filter?.dateTo) params.date_to = filter.dateTo
  return params
}

export function getAllPayments(filter) {
  return apiHelper(API_URL).get('/payments', { params: buildParams(filter) })
}
export function getPayment(docNo) {
  return apiHelper(API_URL).get(`/payments/${docNo}`)
}
